import { useTranslations } from "../../lib/translations"

export function AddZone() {
  const t = useTranslations()
  // M2.6: clicking the + opens a placeholder alert. M4 wires the
  // agent-builder discovery flow into a modal here.
  const onClick = () => alert("New-agent discovery flow lands in M4 (the agent-builder).")
  return (
    <div className="cm-addzone" onClick={onClick} title={t("canvas.add.label")}>
      <svg viewBox="0 0 24 24"><path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5z" /></svg>
      <small>{t("canvas.add.label")}</small>
    </div>
  )
}
